import React, { useEffect, useState } from "react";
import { getMonitoringSearch, getMonitoringTraceability } from "../../../../services/monitoringApi";
import { fmtNum } from "./trafficUtils";
import { TrafficHeadlineCard } from "./TrafficKpiCard";
import VisibilityChain from "./VisibilityChain";
import SignalsList from "./SignalsList";

export default function SummaryPanel({
	websiteId,
	range,
	compare,
	traffic,
	bots,
}) {
	const [search, setSearch] = useState(null);
	const [searchLoading, setSearchLoading] = useState(true);
	const [trace, setTrace] = useState(null);
	const [traceLoading, setTraceLoading] = useState(true);

	const botsParam = bots?.length ? bots.join(",") : undefined;

	useEffect(() => {
		let cancelled = false;
		async function loadSearch() {
			setSearchLoading(true);
			const res = await getMonitoringSearch(websiteId, {
				start: range.start,
				end: range.end,
				compareStart: compare?.start,
				compareEnd: compare?.end,
				searchType: "web",
				engine: "gsc",
			});
			if (cancelled) return;
			setSearch(res.ok ? res.search : null);
			setSearchLoading(false);
		}
		loadSearch();
		return () => {
			cancelled = true;
		};
	}, [websiteId, range.start, range.end, compare?.start, compare?.end]);

	useEffect(() => {
		let cancelled = false;
		async function loadTrace() {
			setTraceLoading(true);
			const res = await getMonitoringTraceability(websiteId, {
				start: range.start,
				end: range.end,
				assistants: botsParam,
			});
			if (cancelled) return;
			setTrace(res.ok ? res.traceability : null);
			setTraceLoading(false);
		}
		loadTrace();
		return () => {
			cancelled = true;
		};
	}, [websiteId, range.start, range.end, botsParam]);

	const days = traffic?.range?.days ?? 14;
	const crawls = traffic?.kpis?.crawl_requests ?? {};
	const visits = traffic?.kpis?.referral_visits ?? {};
	const clicks = search?.kpis?.clicks;

	const trafficUneven = !!traffic?.comparison?.uneven;
	const trafficCompare = traffic?.comparison
		? `vs ${traffic.comparison.start} – ${traffic.comparison.end}`
		: undefined;
	const searchUneven = !!search?.comparison?.uneven;
	const searchCompare = search?.comparison
		? `vs ${search.comparison.start} – ${search.comparison.end}`
		: undefined;

	return (
		<div className="monitoring__ai-traffic-panel">
			<div className="monitoring__ai-traffic-kpi-grid monitoring__ai-traffic-kpi-grid--3">
				<TrafficHeadlineCard
					label={`AI bot crawl requests (${days}d)`}
					value={fmtNum(crawls.value)}
					badge="Cloudflare"
					badgeTone="monitoring__ai-traffic-source-badge--cf"
					kpi={crawls}
					uneven={trafficUneven}
					compareLabel={trafficCompare}
				/>
				<TrafficHeadlineCard
					label={`Organic search clicks (${days}d)`}
					value={searchLoading ? "…" : fmtNum(clicks?.value ?? null)}
					badge="GSC"
					badgeTone="monitoring__ai-traffic-source-badge--gsc"
					kpi={clicks}
					uneven={searchUneven}
					compareLabel={searchCompare}
				/>
				<TrafficHeadlineCard
					label={`AI referral visits (${days}d)`}
					value={fmtNum(visits.value)}
					badge="GA4"
					badgeTone="monitoring__ai-traffic-source-badge--ga4"
					kpi={visits}
					uneven={trafficUneven}
					compareLabel={trafficCompare}
				/>
			</div>

			{trace ? (
				<VisibilityChain data={trace} />
			) : (
				<div className="monitoring__ai-traffic-kpi-card">
					<p className="monitoring__ai-traffic-empty mb-0">
						{traceLoading
							? "Loading the visibility chain…"
							: "Connect Search Console to build the visibility chain."}
					</p>
				</div>
			)}

			<SignalsList
				trafficSignals={traffic?.cross_signals ?? []}
				transitions={trace?.transitions ?? []}
			/>
		</div>
	);
}
